import React from "react";

const PlusIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="22"
      fill="currentColor"
      className="bi bi-plus"
      viewBox="0 0 25 25"
    >
      <path d="M16 8a1 1 0 0 1 1 1v6h6a1 1 0 0 1 0 2h-6v6a1 1 0 0 1-2 0v-6h-6a1 1 0 0 1 0-2h6V9a1 1 0 0 1 1-1" />
    </svg>
  );
};

export default PlusIcon;
